export const environment = {
  title: 'Nedbank Application',
  env_name: 'dev',
  debug: true,
  production: false,
  url: 'https://dev.api.smartfunder.co.za/',
  recaptcha: {
    siteKey: '6LeIYbIqAAAAACSl7DY_KWsWAbMJs71-tmlHU7eQ',
  },
};
